<template>
  <div>
    <div class="row">
      <div class="col-md-10"></div>
      <div class="col-md-2"></div>
    </div>
    <div class="col-md-12">
      <h4>Editar Cidadão</h4>
    </div>
    <div class="col-md-12" v-if="msgAlterada" >
      <div
        class="card"
        style="background-color: rgb(50 170 159) !important;color: #fff !important;margin-bottom: 20px !important;"
        v-if="msg==1"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">{{msgAlterada}}</div>
          </div>
        </div>
      </div>
      <div
        class="card"
        style="background-color: rgb(170 72 50) !important;color: #fff !important;margin-bottom: 20px !important;"
        v-if="msg==0"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">{{msgAlterada}}</div>
          </div>
        </div>
      </div>
      <div
        class="card"
        style="background-color: rgb(191 187 54) !important;color: #fff !important;margin-bottom: 20px !important;"
        v-if="msg==2"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">{{msgAlterada}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12" v-if="verify_senha" >
      <div
        class="card"
        style="background-color: rgb(165 169 168) !important;color: #fff !important;margin-bottom: 20px !important;"
        v-if="msg_senha==1"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">{{msgAlterada_senha}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="row">
        <div class="col-md-6">
          <label>Nome</label>
            <input
              type="text"
              placeholder="Nome"
              maxlength="250"
              v-model="cidadao.nome"
              class="form-control"
              :style="styleNome"
            />
            <label
              class="control-label"
              v-if="styleNome!=''"
              style="color:rgb(243 0 0);font-size: 12px;"
            >*Obrigatorio</label>
        </div>
        <div class="col-md-6" v-if="this.users.admin_sistema">
          <label>Email</label>
            <input
              type="email"
              placeholder="Email"
              maxlength="250"
              v-on:blur="validacaoEmail(cidadao.email)"
              v-model="cidadao.email"
              class="form-control"
              :style="styleEmail"
              readonly
            />
            <div v-if="emailverify==0">
              <label
                class="control-label"
                v-if="styleEmail!=''"
                style="color:rgb(243 0 0);font-size: 12px;"
              >*Obrigatorio</label>
            </div>
            <label
              class="control-label"
              v-if="emailverify==1"
              style="color:rgb(54 154 104);font-size: 12px;"
            >Email Valido!</label>
        </div>
        <div class="col-md-6" v-if="this.users.admin">
            <label>Email</label>
            <input
              type="email"
              placeholder="Email"
              maxlength="250"
              v-on:blur="validacaoEmail(cidadao.email)"
              v-model="cidadao.email"
              class="form-control"
              :style="styleEmail"
            />
            <div v-if="emailverify==0">
              <label
                class="control-label"
                v-if="styleEmail!=''"
                style="color:rgb(243 0 0);font-size: 12px;"
              >*Obrigatorio</label>
            </div>
            <label
              class="control-label"
              v-if="emailverify==1"
              style="color:rgb(54 154 104);font-size: 12px;"
            >Email Valido!</label>
        </div>
      </div>
      <div class="row" style="margin-top:15px; margin-bottom:15px;">
        <div class="col-md-12">

          <label>Senha</label>
            <input
              type="password"
              placeholder="Senha"
              maxlength="250"
              v-on:blur="validacaoSenha(cidadao.senha)"
              v-model="cidadao.senha"
              class="form-control"
              :style="styleSenha"
            />
            <div v-if="senhaverify==0">
              <label
                class="control-label"
                v-if="styleSenha!=''"
                style="color:rgb(243 0 0);font-size: 12px;"
              >*Obrigatorio</label>
            </div>
            <label
              class="control-label"
              v-if="senhaverify==1"
              style="color:rgb(183 179 55);font-size: 12px;"
            >
              * minimo 8 caracteres
              <br />* minimo 1 letra
              <br />* minimo 1 numero
              <br />* minimo 1 caractere especial ex: &!#$
            </label>
        </div>
      </div>
      <div
        class="row"
        v-if="cidadao.tipo =='Física' && this.users.admin_sistema"
        style="margin-bottom:15px;"
      >
        <div class="col-md-12">
          <label>CPF</label>
            <the-mask
              class="form-control"
              placeholder="CPF"
              v-model="cidadao.cpf"
              :mask="['###.###.###-##']"
              :style="styleCpf"
              readonly
            />
            <label
              class="control-label"
              v-if="styleCpf!=''"
              style="color:rgb(243 0 0);font-size: 12px;"
            >*Obrigatorio</label>
        </div>
      </div>
      <div
        class="row"
        v-if="cidadao.tipo =='Física' && this.users.admin"
        style="margin-bottom:15px;"
      >
        <div class="col-md-12">
         <label>CPF</label>
            <the-mask
              class="form-control"
              placeholder="CPF"
              v-model="cidadao.cpf"
              :mask="['###.###.###-##']"
              :style="styleCpf"
            />
            <label
              class="control-label"
              v-if="styleCpf!=''"
              style="color:rgb(243 0 0);font-size: 12px;"
            >*Obrigatorio</label>
        </div>
      </div>

      <div class="row" v-if="cidadao.tipo =='Jurídica' && this.users.admin_sistema">
        <div class="col-md-12">
          <label>CNPJ</label>
            <the-mask
              class="form-control"
              placeholder="CNPJ"
              v-model="cidadao.cnpj"
              :mask="['##.###.###/####-##']"
              :style="styleCnpj"
              readonly
            />
            <label
              class="control-label"
              v-if="styleCnpj!=''"
              style="color:rgb(243 0 0);font-size: 12px;"
            >*Obrigatorio</label>
        </div>
      </div>
      <div class="row" v-if="cidadao.tipo =='Jurídica' && this.users.admin">
        <div class="col-md-12">
          <label>CNPJ</label>
            <the-mask
              class="form-control"
              placeholder="CNPJ"
              v-model="cidadao.cnpj"
              :mask="['##.###.###/####-##']"
              :style="styleCnpj"
            />
            <label
              class="control-label"
              v-if="styleCnpj!=''"
              style="color:rgb(243 0 0);font-size: 12px;"
            >*Obrigatorio</label>
        </div>
      </div>

      <div class="row" style="margin-top:15px;">
        <div class="col-md-12" style="margin-bottom:20px;">
          <label>Telefone Fixo</label>
            <the-mask
              placeholder="Telefone"
              class="form-control"
              :mask="['(##) ####-####', '(##) #####-####']"
              v-model="cidadao.telefone"
              :style="styleTelefone"
            />
            <label
              class="control-label"
              v-if="styleTelefone!=''"
              style="color:rgb(243 0 0);font-size: 12px;"
            >*Obrigatorio</label>
        </div>
        
      </div>
      <div class="row" style="margin-top:15px;">
        <div class="col-md-12" style="margin-bottom:20px;">
          <label>Telefone celular</label>
            <the-mask
              placeholder="Telefone"
              class="form-control"
              :mask="['(##) #####-####']"
              v-model="cidadao.celular"
              :style="styleCelular"
            />
            <label
              class="control-label"
              v-if="styleCelular!=''"
              style="color:rgb(243 0 0);font-size: 12px;"
            >*Obrigatorio</label>
        </div>
      </div>

      <div class="row">
        <div class="col-md-10">
          <base-input
            type="text"
            id="rua"
            name="rua"
            label="Rua"
            placeholder="Rua"
            v-model="cidadao.rua"
            maxlength="150"
          ></base-input>
        </div>
        <div class="col-md-2">
          <base-input
            type="number"
            id="numero"
            name="numero"
            label="Número"
            placeholder="Número"
            v-model="cidadao.numero"
            maxlength="150"
          ></base-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-9">
          <base-input
            type="text"
            id="bairro"
            name="bairro"
            label="Bairro"
            placeholder="Bairro"
            v-model="cidadao.bairro"
            maxlength="150"
          ></base-input>
        </div>
        <div class="col-md-3">
          <base-input
            type="text"
            id="complemento"
            name="complemento"
            label="Complemento"
            placeholder="Complemento"
            v-model="cidadao.complemento"
            maxlength="150"
          ></base-input>
        </div>
        <div class="col-md-5">
          <base-input
            type="text"
            id="CEP"
            name="CEP"
            label="CEP"
            placeholder="CEP"
            v-model="cidadao.cep"
            maxlength="150"
          ></base-input>
        </div>
        <div class="col-md-3">
          <base-input
            type="text"
            id="Estado"
            name="Estado"
            label="Estado"
            placeholder="Estado"
            v-model="cidadao.estado"
            maxlength="150"
          ></base-input>
        </div>
      </div>

      <div class="row">
        <div class="text-center" style="margin-left:15px">
          <button
            type="button"
            class="btn btn-primary btn-fill float-left"
            @click.prevent="editarform"
          >Editar</button>
          <button class="btn btn-danger" @click="retornar()" style="margin-left: 8px;">Cancelar</button>
        </div>
      </div>

      <div class="clearfix"></div>
    </div>
  </div>
</template>
<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import axios from "axios";
import store from "src/store.js";
import "src/controller/sistema/cidadaoController.js";
import "src/controller/sistema/usuarioController.js";

export default {
  name: "my-component",
  components: {
    VueGoodTable,
  },
  props: {
    row: {
      require: true,
    },
  },
  data() {
    return {
      mask: "(00)00000-0000",
      maskcpf: "000.000.000-00",
      maskcnpj: "00.000.000/0000-00",
      cidadao: {
        nome: null,
        email: null,
        senha: null,
        tipo: null,
        cpf: null,
        cnpj: null,
        cep:null,
        tipotelefone:null,
        telefone: null,
        celular: null,
        tipocelular:null,
        rua: null,
        numero: null,
        bairro: null,
        complemento: null,
        estado:null,
      },
      users: {
        admin: null,
        admin_sistema: null,
      },
      msgAlterada: null,
      msg: null,
      msgAlterada_senha:null,
      msg_senha:null,
      emailverify: 0,
      styleNome: "",
      styleEmail: "",
      styleSenha: "",
      styleCelular: "",
      styleCnpj: "",
      styleCpf: "",
      styleTelefone: "",
      emailverify: 0,
      senhaverify: 0,
      verify_email: false,
      verify_senha: false,
    };
  },
  methods: {
    retornar() {
      this.$router.push("/sistema/cidadaos");
    },
    validacaoEmail(email) {
      if (email) {
        if (email.indexOf("@") >= 0) {
          if (email.indexOf(".") >= 0) {
            /*let separar = email.split("@");
                console.log(separar[0]); 
                console.log(separar[1]); */
            this.msgAlterada = "";
            this.styleEmail = "border: 2px solid rgb(64 185 124);";
            this.emailverify = 1;
            this.verify_email = true;
            return true;
          } else {
            //email.log("Não é um Email valido!")
            this.styleEmail = "border: 2px solid rgb(243 0 0);";
            this.msgAlterada = "Não é um Email valido!";
            this.emailverify = 0;
            this.verify_email = false;
            this.msg = 0;
            return false;
          }
        } else {
          //email.log("Não é um Email valido!")
          this.styleEmail = "border: 2px solid rgb(243 0 0);";
          this.msgAlterada = "Não é um Email valido!";
          this.emailverify = 0;
          this.verify_email = false;
          this.msg = 0;
          return false;
        }
      } else {
        this.styleEmail = "border: 2px solid rgb(243 0 0);";
        this.msgAlterada = "O campo Email está Vazio!";
        this.emailverify = 0;
        this.verify_email = false;
        this.msg = 0;
        return false;
      }
    },
    validacaoSenha(senha) {
      if (senha) {
        this.styleSenha = "";
        this.msgAlterada = "";
        this.senhaverify = 0;

        if (senha.length <= 8) {
          this.msgAlterada =
            "O campo Senha tem que ter no minimo 8 Caracteres!";
          this.msg = 2;
          this.senhaverify = 1;
          this.verify_senha = false;
          return false;
        } else {
          this.msgAlterada = "";
        }

        if (senha.search(/[a-z]/i) < 0) {
          this.msgAlterada = "O campo Senha deve possuir no minimo uma letra!";
          this.msg = 2;
          this.senhaverify = 1;
          this.verify_senha = false;
          return false;
        } else {
          this.msgAlterada = "";
        }

        if (senha.search(/[0-9]/i) < 0) {
          this.msgAlterada = "O campo Senha deve possuir no minimo um numero!";
          this.msg = 2;
          this.senhaverify = 1;
          this.verify_senha = false;
          return false;
        } else {
          this.msgAlterada = "";
        }

        if (senha.search(/[!@#$%^&*]/i) < 0) {
          this.msgAlterada =
            "O campo Senha deve possuir no minimo um caracter especial!";
          this.msg = 2;
          this.senhaverify = 1;
          this.verify_senha = false;
          return false;
        } else {
          this.msgAlterada = "";
        }

        this.senhaverify = 0;
        this.verify_senha = true;
      } else {
        this.msgAlterada_senha= "A senha não foi alterada!"
        this.msg_senha = 1;
        this.senhaverify = 0;
        this.verify_senha = true;
      }
    },
    async editarform() {
     
      this.msgAlterada = null;
      this.msgAlterada_senha = null;
      this.msg = null;
      this.styleNome = "";
      this.styleEmail = "";
      this.styleSenha = "";
      this.styleCpf = "";
      this.styleCnpj = "";
      this.styleTelefone = "";

      if (this.cidadao.nome == null || this.cidadao.nome == "") {
        this.styleNome = "border: 2px solid rgb(243 0 0);";
        this.msgAlterada = "O campo Nome está Vazio!";
        this.msg = 0;
        return false;
      }
      if (this.cidadao.email == null || this.cidadao.email == "") {
        this.styleEmail = "border: 2px solid rgb(243 0 0);";
        this.msgAlterada = "O campo Email está Vazio!";
        this.verify_email = false;
        this.msg = 0;
        return false;
      }

      if (this.cidadao.tipo == "Física") {
        this.cidadao.cnpj = null;
        if (this.cidadao.cpf == null || this.cidadao.cpf == "") {
          this.styleCpf = "border: 2px solid rgb(243 0 0);";
          this.msgAlterada = "O campo CPF está Vazio!";
          this.msg = 0;
          return false;
        }
      }

      if (this.cidadao.tipo == "Jurídica") {
        this.cidadao.cpf = null;
        if (this.cidadao.cnpj == null || this.cidadao.cnpj == "") {
          this.styleCnpj = "border: 2px solid rgb(243 0 0);";
          this.msgAlterada = "O campo CNPJ está Vazio!";
          this.msg = 0;
          return false;
        }
      }

      if (this.cidadao.telefone == null || this.cidadao.telefone == "") {
        this.styleTelefone = "border: 2px solid rgb(243 0 0);";
        this.msgAlterada = "O campo Telefone está Vazio!";
        this.msg = 0;
        return false;
      }

      if (this.cidadao.celular == null || this.cidadao.celular == "") {
        this.styleCelular = "border: 2px solid rgb(243 0 0);";
        this.msgAlterada = "O campo Celular está Vazio!";
        this.msg = 0;
        return false;
      }
      this.validacaoSenha(this.cidadao.senha); 
      if (this.cidadao.senha == null || this.cidadao.senha == "") {
        this.msgAlterada_senha= "A senha não foi alterada!"
        this.msg_senha = 1;
        this.senhaverify = 0;
        this.verify_senha = true;
      }
      
      if(this.verify_senha){
        let me = await this.$me();
        let data = await this.$cidadaoEdit(this.row.uuid, this.cidadao, me.id);
        
        if (data.data == "Editado com sucesso!") {
          this.msgAlterada = data.data;
          this.msg = 1;
        }
        
        if (data.msg == "CPF já está em uso!") {
          this.msgAlterada = data.msg;
          this.styleCpf = "border: 2px solid rgb(243 0 0);";
          this.msg = 0;
          return false;
        }
        if (data.msg == "CPF invalido!") {
          this.msgAlterada = data.msg;
          this.styleCpf = "border: 2px solid rgb(243 0 0);";
          this.msg = 0;
          return false;
        }
        if (data.msg == "CNPJ invalido!") {
          this.msgAlterada = data.msg;
          this.styleCnpj = "border: 2px solid rgb(243 0 0);";
          this.msg = 0;
          return false;
        }
        if (data.msg == "CNPJ já está em uso!") {
          this.msgAlterada = data.msg;
          this.styleCnpj = "border: 2px solid rgb(243 0 0);";
          this.msg = 0;
          return false;
        }
        if (data.msg == "Email já está em uso!") {
          this.msgAlterada = data.msg;
          this.styleEmail = "border: 2px solid rgb(243 0 0);";
          this.emailverify = 0;
          this.msg = 0;
          return false;
        }
        
        
        let t = await this.$telefoneEdit(this.row.uuid, this.cidadao.telefone,this.cidadao.tipotelefone);
        let en = await this.$enderecoEdit(this.row.uuid, this.cidadao);
        let t2 = await this.$telefoneEdit(this.row.uuid, this.cidadao.celular,this.cidadao.tipocelular);

        setTimeout( () => this.$router.push({ path: '/sistema/cidadaos'}), 150);
      }
    },
    async telefoneGet() {
      let data = await this.$telefoneGet(this.row.uuid);
      if(data.data[0].tipo =='Fixo'){
         this.cidadao.telefone = data.data[0].telefone;
         this.cidadao.tipotelefone = 'Fixo';
      }else{
        this.cidadao.telefone = data.data[1].telefone;
        this.cidadao.tipotelefone = 'Fixo';
      }

      if(data.data[0].tipo =='Celular'){
        this.cidadao.celular = data.data[0].telefone;
        this.cidadao.tipocelular = 'Celular';
      }else{
        this.cidadao.celular = data.data[1].telefone;
        this.cidadao.tipocelular = 'Celular';
      }

    },
    async enderecoGet() {
      let data = await this.$enderecoGet(this.row.uuid);
      let dados = data.data;

      dados.forEach((element) => {
        this.cidadao.rua = element.rua;
        this.cidadao.numero = element.numero;
        this.cidadao.bairro = element.bairro;
        this.cidadao.complemento = element.complemento;
      });
      //this.cidadao.rua = data.data[0].rua;
    },
  },
  beforeMount() {
    try {
      if (this.row == null) {
        this.$router.push("/sistema/cidadaos");
      } else {
        //console.log(this.row);
        this.cidadao.nome = this.row.nome;
        this.cidadao.email = this.row.email;
        this.cidadao.tipo = this.row.tipo;
        this.cidadao.cpf = this.row.cpf;
        this.cidadao.cnpj = this.row.cnpj;
        this.cidadao.estado = this.row.estado;
        this.cidadao.cep = this.row.cep;
        this.telefoneGet();
        this.enderecoGet();

        this.users.admin = store.admin;
        this.users.admin_sistema = store.admin_sistema;
      }
    } catch (e) {}
  },
};
</script>

